import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "documentation__text" }, "This project was created with the aim of mastering the practice and developing skills with the work of the API.", -1)
const _hoisted_2 = { class: "documentation__text" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "documentation__text" }, [
  /*#__PURE__*/_createTextVNode("The project was created by me. You can go to my "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/Nick8582" }, "GitHub page"),
  /*#__PURE__*/_createTextVNode(".")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode("To work with this project, you need to go to the "),
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("\"Home\"")
        ]),
        _: 1
      }),
      _createTextVNode(" page and enter the required city. Then click on the \"add\" button.")
    ]),
    _hoisted_3
  ]))
}